import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './offer-card.magic.css.js';
import script from './offer-card.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offer)?_c('div',{staticClass:"offer",attrs:{"part":"offer","data-v-test-id":"offer-card"}},[_c('div',{staticClass:"header",attrs:{"part":"header"}},[(_vm.showImage && _vm.src)?_c('picture',{staticClass:"picture",attrs:{"part":"picture"}},[_c('source',{attrs:{"type":"image/avif","srcset":_vm.avifSrcset}}),_vm._v(" "),_c('source',{attrs:{"type":"image/webp","srcset":_vm.webpSrcset}}),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"part":"image","loading":"lazy","src":_vm.src,"alt":_vm.offer.title}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"part":"content"}},[_c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[_c('magic-ui-text',{staticClass:"title",attrs:{"inherit-weight":"","tag":"h2","part":"title","content":_vm.offer.title,"data-v-test-id":"offer-card-title"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"title title--subtitle",attrs:{"inherit-weight":"","tag":"h3","part":"title title--subtitle","content":_vm.offer.content.title,"data-v-test-id":"offer-card-subtitle"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.offer.content.body,"data-v-test-id":"offer-card-body"}})],1),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},_vm._l((_vm.offer.cta),function(cta,index){return _c('a',{key:index + cta.desktop,staticClass:"link",attrs:{"part":"link","target":cta.target || '_self',"href":cta.desktop,"data-v-test-id":"offer-card-cta"}},[_vm._v("\n                "+_vm._s(cta.text)+"\n            ")])}),0)])]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-19fc2bb0_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-19fc2bb0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
